var map = {
	"./buses-icon-blue.PNG": 160,
	"./buses-icon.PNG": 161,
	"./cabs-icon-blue.PNG": 162,
	"./cabs-icon.PNG": 163,
	"./charter-flights-icon-blue.PNG": 164,
	"./charter-flights-icon.PNG": 165,
	"./flights-icon-blue.PNG": 166,
	"./flights-icon.PNG": 167,
	"./gift-icon.png": 168,
	"./google-icon.png": 84,
	"./holidays-icon-blue.PNG": 169,
	"./holidays-icon.PNG": 170,
	"./hotels-icon-blue.PNG": 171,
	"./hotels-icon.PNG": 172,
	"./info-btn-1-bg.png": 87,
	"./info-btn-1.jpg": 173,
	"./info-btn-2-bg.png": 88,
	"./info-btn-2.jpg": 174,
	"./info-btn-3-bg.png": 89,
	"./info-btn-3.jpg": 175,
	"./info-btn-4-bg.png": 90,
	"./info-btn-4.jpg": 176,
	"./info-btn-5-bg.png": 177,
	"./info-btn-5.jpg": 178,
	"./more-icon.PNG": 179,
	"./pay-icon.png": 180,
	"./trains-icon-blue.PNG": 181,
	"./trains-icon.PNG": 182,
	"./villas-icon-blue.PNG": 183,
	"./villas-icon.PNG": 184,
	"./visa-icon-blue.PNG": 185,
	"./visa-icon.PNG": 186,
	"./voucher-icon.png": 187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;